import { render } from "./Notes.vue?vue&type=template&id=3fa81a5c&scoped=true&ts=true"
import script from "./Notes.vue?vue&type=script&lang=ts"
export * from "./Notes.vue?vue&type=script&lang=ts"

import "./Notes.vue?vue&type=style&index=0&id=3fa81a5c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1462515960/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa81a5c"]])

export default __exports__